import { oneOf as codecOneOf } from 'purify-ts/Codec';
import { makeResponses } from '../response_factory';
import { utils as coreUtils, requestParams } from '@codegrade/api-core';
import { AllSiteSettings, FrontendSiteSettings, PatchSiteSettingsData, } from '@codegrade/api-models';
import { parsers } from '@codegrade/utils';
const makeResult = coreUtils.makeResult;
// eslint-disable-next-line @typescript-eslint/no-unused-vars,unused-imports/no-unused-vars
const parseJsonResponse = /* #__PURE__ */ parsers.parseJsonResponse;
export function siteSettings(config) {
    const getAllResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(
        /* #__PURE__ */ parseJsonResponse(
        /* #__PURE__ */ codecOneOf([AllSiteSettings, FrontendSiteSettings]))),
    });
    const patchResponse = /* #__PURE__ */ makeResponses({
        200: /* #__PURE__ */ makeResult(/* #__PURE__ */ parseJsonResponse(AllSiteSettings)),
    });
    return Object.freeze({
        /**
         * Get the settings for this CodeGrade instance.
         *
         * @param arg The arguments to the function.
         * @param arg.onlyFrontend Get only the frontend settings.
         * @returns The site settings for this instance.
         */
        getAll: async ({ onlyFrontend = undefined, }) => {
            const result = await requestParams(config, 'GET', `/api/v1/site_settings/`, getAllResponse.v, undefined, {
                only_frontend: onlyFrontend,
            });
            return result;
        },
        /**
         * Update the settings for this CodeGrade instance.
         *
         * @param arg The arguments to the function.
         * @param arg.requestBody The body of the request.
         * @returns The updated site settings.
         */
        patch: async ({ requestBody, }) => {
            const result = await requestParams(config, 'PATCH', `/api/v1/site_settings/`, patchResponse.v, JSON.stringify(PatchSiteSettingsData.encode(requestBody)));
            return result;
        },
    });
}
